export default __webpack_public_path__ + "locales/lv/Common.json?hash=43c48bce49c1f909262e2ac495c67e2f";